import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-200 hover:border-primary-200 cursor-pointer ${
        isLarge ? 'flex flex-col sm:flex-row' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${isLarge ? 'sm:w-48 shrink-0' : ''}`}>
        <div className={isLarge ? 'aspect-[3/4] sm:aspect-[3/4]' : 'aspect-[3/4]'}>
          <img
            src={comic.coverImage}
            alt={`${comic.title} - 歪歪漫画在线免费阅读`}
            title={`${comic.title} - 歪歪漫画在线免费观看`}
            className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
            连载中
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs bg-secondary-500 text-background-50 rounded-md whitespace-nowrap">
            已完结
          </span>
        )}
      </div>

      <div className={`p-3 md:p-4 ${isLarge ? 'flex-1 flex flex-col justify-center' : ''}`}>
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        {!isLarge && (
          <p className="text-xs text-foreground-400 mt-2 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}
        {isLarge && (
          <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {comic.rating}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {comic.views >= 10000
              ? `${(comic.views / 10000).toFixed(0)}万`
              : comic.views}
          </span>
          <span className="ml-auto text-foreground-400">{comic.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}